import { BaseWithId } from '@app/shared/models/base';
import { BaseWithIdList } from '@app/shared/models/list';
import { PaginatedResponse } from '@app/shared/models/pagination';
import { Address } from '@app/shared/models/address';
import { ActionListItem } from '@app/shared/components/action-list/action-list.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { AlphabetFilterable } from '@app/shared/models/search-filter';
import { Gender } from '@app/shared/models/gender';

export class AddressBookEntry extends BaseWithId
                              implements ActionListItem, AlphabetFilterable {
    public clientId: string;
    public title: string;
    public name1: string;
    public name2: string;
    public name3: string;
    public tax_deduction: boolean;
    public comment: string;
    public address: Address;
    public alphabetFilterOn: string[];
    public gender: Gender;
    public cost_center: string;

    private _actionListDisplayName: string;

    public trans = {
        mr: marker('participant.title.mr'),
        ms: marker('participant.title.ms'),
        not_specified: marker('participant.title.not_specified'),
        name1: marker('participant.name1'),
        name2: marker('participant.name2'),
        name3: marker('participant.name3'),
        tax_deduction: marker('participant.tax_deduction'),
        comment: marker('participant.comment'),
        cost_center: marker('participant.cost_center')
    };

    get actionListDisplayName(): string {
        return this._actionListDisplayName ||
               `${this.name1 ? `${this.name1}${this.name2 || this.name3 || (this.address && (this.address.postalcode || this.address.city)) ? `, ` : ``}` : ``}
                ${this.name2 ? `${this.name2}${this.name3 || (this.address && (this.address.postalcode || this.address.city)) ? `, ` : ``}` : ``}
                ${this.name3 ? `${this.name3}${this.address && (this.address.postalcode || this.address.city) ? `, ` : ``}` : ``}
                ${this.address && this.address.postalcode ? `${this.address.postalcode}${this.address.city ? `, ` : ``}` : ``}
                ${this.address && this.address.city || ``}`;
    }

    set actionListDisplayName(actionListDisplayName: string) {
        this._actionListDisplayName = actionListDisplayName;
    }

    constructor(json?: any) {
        super(json);
    }

    public static sortByActionListDisplayName(entry1: AddressBookEntry, entry2: AddressBookEntry): number {
        if (entry1.actionListDisplayName < entry2.actionListDisplayName) { return -1; }
        if (entry1.actionListDisplayName > entry2.actionListDisplayName) { return 1; }
        return 0;
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            address: new Address(json && json.address),
            alphabetFilterOn: []
        });
    }
}

export class AddressBookEntryList extends BaseWithIdList<AddressBookEntry>
                                  implements PaginatedResponse {
    public row_count: number;
    public from: number;
    public limit: number;

    public initialize(json?: any): void {
        if (json) {
            this.row_count = json.row_count;
            this.from = json.from;
            this.limit = json.limit;
            this.items = json.contacts ? json.contacts.map(contact => new AddressBookEntry(contact.contact)) : [];
        }
    }
}
